import { defineMessages } from 'react-intl';

const translationMessages = defineMessages({
  lighting: {
    id: 'hosting.pages_collection.lighting',
    defaultMessage: 'Lighting'
  },
  sound: {
    id: 'hosting.pages_collection.sound',
    defaultMessage: 'Sound'
  },
  access: {
    id: 'hosting.pages_collection.access',
    defaultMessage: 'Space Access'
  },
  electrical: {
    id: 'hosting.pages_collection.electrical',
    defaultMessage: 'Electrical'
  },
  rules: {
    id: 'hosting.pages_collection.rules',
    defaultMessage: 'Production Rules'
  }
});
export default [
  { page: 'lighting', label: translationMessages.lighting },
  { page: 'sound', label: translationMessages.sound },
  { page: 'access', label: translationMessages.access },
  { page: 'electrical', label: translationMessages.electrical },
  { page: 'rules', label: translationMessages.rules }
];
